module.exports = __webpack_public_path__ + "static/img/物联网.8e218de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/物联网.jpg
// module id = ndrv
// module chunks = 1